export default "__VITE_ASSET__BiWBQ6XY__"